<script>
// import Layout from '@layouts/main'

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  name: 'Loading',
}
</script>

<template>
  <div class="local-preloader">
    <div class="status">
      <div class="spinner">
        <div class="circle1"></div>
        <div class="circle2"></div>
        <div class="circle3"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.loadingIcon {
  display: block;
  margin: 0 auto;
}
.local-preloader {
  background-color: rgba(237, 239, 244, 0.75) !important;
}
</style>
